export default __webpack_public_path__ + "static/media/mum1.826066ac.826066ac.png";